import React, { Component } from "react";
import IssueAgeing from "./IssueAgeing";
import { connect } from "react-redux";
import { get } from "lodash";
import UpcomingMOM from "../MOM/UpcomingMOM";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  issueActivityHistory,
  issueActivityComment,
  getAgeingAction,
  getUpcomingMeetings
} from "../../actions/issueDetail.action";
import { bindActionCreators } from "redux/es/redux";
import { dateFormat, isValidArray, getLocalstorage } from "../../helper";
import { STATUS } from "../../constant";
import LoaderTemplate from "../../component/LoaderTemplate";
import { AgeingLoaderTemplate } from "../../component/LoadersTemplate";
import NoDataFound from "../../component/NoDataFound";
import Comment from "../IssueHistoryAndComments/IssueComment";
import History from "../IssueHistoryAndComments/History";
import Decision from "../IssueHistoryAndComments/Decision";
import UpcomingMeetingLoader from "../../component/LoadersTemplate/UpcomingMeetingLoader";
import LinkContext from "./LinkContext";
import introJs from "intro.js";
import clock from "../../assets/clock.gif";
import { getDate, getTime } from "date-fns";

class IssueDetailsSideBar extends Component {
  isApiCalled = false;
  state = {
    type: "comment",
    history: [],
    comment: [],
    ageingData: {},
    isHistoryApiLoading: STATUS.LOADING,
    isAgeingLoading: STATUS.LOADING,
    upcomingMeetingsStatus: STATUS.LOADING,
    isIssueAgeing: false,
    isUpcomingMeetings: false,
    isIssueProgress: false,
    commentCount: null
  };

  componentDidMount() {
    let { issueData, issueDetailId } = this.props;
    this.isApiCalled = true;
    this.getApiCalled("comment", issueData);
    this.getAgeingData(get(issueData, "data.id"));
    this.getUpcommingData(get(issueData, "data.id"));
    //this.getCommentData(issueDetailId);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { issueData, awakeSideBar } = nextProps;
    if (
      (issueData &&
        get(this.props.issueData, "data.id") !== get(issueData, "data.id")) ||
      awakeSideBar
    ) {
      this.isApiCalled = true;
      this.getApiCalled("comment", issueData);
      this.getAgeingData(get(issueData, "data.id"));
      this.getUpcommingData(get(issueData, "data.id"));
    }
  }

  getAgeingData = async id => {
    const { getAgeingDispatch } = this.props;
    this.setState({ isAgeingLoading: STATUS.LOADING });
    const resp = await getAgeingDispatch(undefined, { issueId: id });
    if (resp) {
      const { data, status } = resp;
      this.setState({
        isAgeingLoading: (status && STATUS.SUCCESS) || STATUS.ERROR,
        ageingData: data
      });
    } else {
      this.setState({
        isHistoryApiLoading: STATUS.ERROR
      });
    }
  };

  getUpcommingData = async id => {
    const { getUpcomingMeetingsDispatch } = this.props;
    const resp = await getUpcomingMeetingsDispatch(undefined, id);
    this.setState({
      upcomingMeetingsStatus: STATUS.LOADING
    });
    if (resp) {
      this.setState({
        upcomingMettingData: get(resp, "data", []),
        upcomingMeetingsStatus: STATUS.SUCCESS
      });
    }
  };

  getApiCalled = (type, issueDetail) => {
    const {
      issueActivityHistoryDispatch,
      issueActivityCommentDispatch,
      issueData,
      meetingDecisions
    } = this.props;
    const issue = issueDetail || issueData;

    if (issue) {
      let idsOfIssues = [];
      if (issue.data != null) {
        if (issue.data.parent && type === "comment") {
          idsOfIssues = [{ issueId: get(issue, "data.id") }].concat(
            issue &&
              issue.data &&
              issue.data.siblings &&
              issue.data.siblings.length &&
              issue.data.siblings.map(value => {
                return { issueId: value.id };
              }),
            issue && issue.data && { issueId: issue.data.parent }
          );
        } else {
          if (type === "decision") {
            const highlightedElement = document.querySelector(
              ".introjs-helperLayer"
            );
            if (highlightedElement) {
              introJs().exit();
            }
          } else {
            idsOfIssues = [{ issueId: get(issue, "data.id") }].concat(
              issue &&
                issue.data &&
                issue.data.childs &&
                issue.data.childs.length &&
                issue.data.childs.map(value => {
                  return { issueId: value.id };
                })
            );
          }
        }
      }
      const idsOfIssuesWithDuplicateIssues = (idsOfIssues || []).concat(
        issue &&
          issue.data &&
          issue.data.duplicateIssues &&
          issue.data.duplicateIssues.length &&
          issue.data.duplicateIssues.map(value => {
            return { issueId: value };
          })
      );
      this.setState(
        {
          type: type,
          history: [],
          //comment: [],
          isHistoryApiLoading: STATUS.LOADING
        },
        async () => {
          let api =
            type === "comment"
              ? issueActivityCommentDispatch
              : issueActivityHistoryDispatch;
          Promise.all(
            idsOfIssuesWithDuplicateIssues.map(value => {
              return api(undefined, value);
            })
          ).then(resp => {
            this.setState({
              [type]: resp.map((value, index) => {
                return (
                  value &&
                  value.data &&
                  value.data.length &&
                  value.data.map(_issue => {
                    _issue.issueId =
                      idsOfIssuesWithDuplicateIssues[index]["issueId"];
                    if (
                      issue.data &&
                      issue.data.duplicateIssues &&
                      issue.data.duplicateIssues.length
                    ) {
                      _issue.isIssueDuplicate = issue.data.duplicateIssues.includes(
                        idsOfIssuesWithDuplicateIssues[index]["issueId"]
                      );
                    }
                    return _issue;
                  })
                );
              }),
              isHistoryApiLoading: STATUS.SUCCESS
            });
          });
        }
      );
    }
  };

  handleIssues = key => {
    let { isIssueAgeing, isUpcomingMeetings, isIssueProgress } = this.state;
    switch (key) {
      case "issueAgeing":
        this.setState({ isIssueAgeing: !isIssueAgeing });
        break;
      case "upcomingMeetings":
        this.setState({ isUpcomingMeetings: !isUpcomingMeetings });
        break;
      case "issueProgress":
        this.setState({ isIssueProgress: !isIssueProgress });
        break;
      default:
        break;
    }
  };

  getCommentCount = data => {
    const dataToIterate = data
      ? isValidArray(data.filter(value => isValidArray(value)))
      : [];
    const commentList = [];
    let commentExists = false;
    if (isValidArray(dataToIterate)) {
      dataToIterate.forEach(data => {
        data.forEach(comment => {
          if (!comment.isAutomated) {
            commentList.push(comment);
          }
          if (comment.isAutomated && !comment.isChildIssueComment) {
            commentList.push(comment);
          }
          if (
            comment.isAutomated &&
            comment.isChildIssueComment &&
            comment.isChildResolved
          ) {
            commentList.push(comment);
          }
        });
      });
    }
    return commentList.length;
    // this.setState({
    //   commentCount: commentList.length
    // });
    // console.log("commentList", commentList.length);
  };
  getAllComments = data => {
    console.log(data);
    if (data == "comment") {
      this.getApiCalled(data);
    }
  };
  render() {
    const {
      history,
      type,
      comment,
      isAgeingLoading,
      isHistoryApiLoading,
      ageingData,
      upcomingMettingData,
      upcomingMeetingsStatus,
      isIssueAgeing,
      isUpcomingMeetings,
      isIssueProgress
    } = this.state;

    const { issueData, meetingDecisions } = this.props;
    const CommentCountData = this.getCommentCount(comment);
    const tooltipText = (
      <div className="clock-popup">
        Compliance Timeline Missed. <br />
        Click on Decisions for Details!
      </div>
    );

    const latestDate =
      meetingDecisions &&
      meetingDecisions.reduce((maxDate, task) => {
        const taskDate =
          task.meetingId != null ? new Date(task.taskCompletionDate) : "";
        return taskDate > maxDate ? taskDate : maxDate;
      }, new Date(0));

    const meetingDecisionSub =
      meetingDecisions &&
      meetingDecisions.reduce((maxDate, task) => {
        const taskDate =
          task.meetingId != null ? new Date(task.decisionSubmittedOn) : "";
        return taskDate > maxDate ? taskDate : maxDate;
      }, new Date(0));

    const tooltipStyle = {
      background: "transparent",
      height: "58px"
    };
    const userInfo = getLocalstorage("user");
    const centralIssue =
      get(issueData, "data.projectIssueDTO.workflowType") === "CENTRAL";

    //  const isUserPMG = get(userInfo, "groupCategory") === "PMG" && centralIssue;

    const allowedStatuses = [
      "Pending with RM/RS",
      "Under PMG Decision",
      "Resolved"
    ];

    const AIbuttonVisibility =
      centralIssue &&
      allowedStatuses.includes(get(issueData, "data.issueStatusName"));
    return (
      <React.Fragment>
        <div className="issue-sidebar-inner">
          <div className="issue-ageing-wrapper accordion-wrapper">
            {" "}
            {/*accordion-visible*/}
            <div className="ia-wrapper-inner">
              <div>
                <h2
                  className="accordion-heading"
                  onClick={() => this.handleIssues("issueAgeing")}
                >
                  Issue Ageing
                </h2>
              </div>
              <div className="ia-day-count">
                <b>
                  {(get(ageingData, "groupAgeingDTOS") &&
                    get(ageingData, "totalDays", "NA")) ||
                    0}{" "}
                  Days
                </b>

                <div className="know-hierarchy know-hierarchy-progress">
                  <b>Know More</b>
                  <ul className="ia-hierarchy-progress">
                    <li>
                      <div
                        className={`accordion-content ${
                          isIssueAgeing ? `link-display` : `link-hide`
                        }`}
                      >
                        {isAgeingLoading === STATUS.LOADING ? (
                          <LoaderTemplate
                            height={60}
                            width={450}
                            children={<AgeingLoaderTemplate />}
                          />
                        ) : get(ageingData, "groupAgeingDTOS") &&
                          isValidArray(
                            Object.keys(get(ageingData, "groupAgeingDTOS"))
                          ) ? (
                          <>
                            <div className="issue-ageing-info-text">
                              Number of days since the Issue is pending with the
                              following stakeholder(s):
                            </div>
                            {Object.keys(
                              get(ageingData, "groupAgeingDTOS", {})
                            ).map((name, index) => (
                              <React.Fragment key={`name-${index}`}>
                                <IssueAgeing
                                  issueStatus={
                                    issueData &&
                                    issueData.data &&
                                    issueData.data.issueStatusName
                                  }
                                  issueId={ageingData.issueId}
                                  totalDays={ageingData.totalDays}
                                  ageingData={ageingData.groupAgeingDTOS[name]}
                                  ageingName={name}
                                />
                              </React.Fragment>
                            ))}
                          </>
                        ) : (
                          <NoDataFound />
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {isValidArray(upcomingMettingData) &&
          upcomingMettingData.length > 0 ? (
            <div className="upcoming-meetings accordion-wrapper">
              {" "}
              {/*accordion-visible*/}
              <div className="ia-wrapper-inner">
                <div>
                  <h2
                    className="accordion-heading"
                    onClick={() => this.handleIssues("upcomingMeetings")}
                  >
                    Upcoming Meetings
                  </h2>
                </div>
                <div className="agenda-meet-count">
                  <div className="agenda-count">
                    <div>
                      <b>{upcomingMettingData.length}</b>
                    </div>
                    <div className="agenda-number" />
                  </div>
                  <div className="know-hierarchy know-agenda-progress dropdown">
                    <b>Know More</b>
                    <ul className="dropdown-content">
                      <li>
                        <div
                          className={`accordion-content ${
                            isUpcomingMeetings ? `link-display` : `link-hide`
                          }`}
                        >
                          {upcomingMeetingsStatus === STATUS.LOADING ? (
                            <LoaderTemplate
                              height={60}
                              times={3}
                              children={<UpcomingMeetingLoader />}
                            />
                          ) : (
                            (isValidArray(upcomingMettingData) &&
                              upcomingMettingData.map((list, index) => (
                                <UpcomingMOM
                                  meetingDecisionDTOS={list}
                                  key={`mom-${index}`}
                                />
                              ))) || (
                              <Image
                                src="https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_comments.png"
                                alt="No Meetings"
                                className="no-comments-image"
                              />
                            )
                          )}

                          {/*{(upcomingMettingData || []).map((list, index) => (*/}
                          {/*<UpcomingMOM meetingDecisionDTOS={list} key={`mom-${index}`} />*/}
                          {/*)) || null}*/}

                          {/*<Button className="btn-orange-invert no-padding btn-small">*/}
                          {/*View Details*/}
                          {/*</Button>*/}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <div className="activity-history-wrapper accordion-wrapper">
            {" "}
            <h2
              className="accordion-heading"
              onClick={() => this.handleIssues("issueProgress")}
            >
              Issue Progress Timeline
              {isValidArray(meetingDecisions) &&
              issueData.data.issueStatus !== "RESOLVED" ? (
                meetingDecisions.some(
                  item =>
                    getTime(meetingDecisionSub) ==
                      getTime(item.decisionSubmittedOn) &&
                    new Date(item.taskCompletionDate).setHours(0, 0, 0, 0) <
                      new Date().setHours(0, 0, 0, 0) &&
                    item.taskCompletionDate != null &&
                    item.meetingId
                ) ? (
                  <OverlayTrigger
                    placement={"top"}
                    overlay={
                      <Tooltip
                        id={""}
                        className="background-popup"
                        style={tooltipStyle}
                      >
                        <div>{tooltipText}</div>
                      </Tooltip>
                    }
                  >
                    <Image src={clock} alt="clock" className="issue-clock" />
                  </OverlayTrigger>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </h2>
            <div
              className={`accordion-content ${
                isIssueProgress ? `link-display` : `link-hide`
              }`}
            >
              <div className="ah-content-head">
                <h2
                  className={`ah-heading ${type === "comment" && "active"}`}
                  onClick={() => {
                    this.getApiCalled("comment");
                  }}
                >
                  Comments ({CommentCountData})
                </h2>

                <LinkContext.Consumer>
                  {context => (
                    <h2
                      className={`ah-heading ${type === "decision" &&
                        "active"}`}
                      onClick={() => {
                        this.getApiCalled("decision");
                      }}
                      ref={context}
                    >
                      Decisions (
                      {meetingDecisions !== null ? meetingDecisions.length : 0})
                    </h2>
                  )}
                </LinkContext.Consumer>
                <h2
                  className={`ah-heading ${type === "history" && "active"}`}
                  onClick={() => {
                    this.getApiCalled("history");
                  }}
                >
                  Updates
                </h2>
              </div>
              <div
                className={`ah-content-wrapper ${type === "comment" &&
                  "active"}`}
              >
                {(type === "comment" && (
                  <Comment
                    isLoading={isHistoryApiLoading}
                    data={comment}
                    isUserPMG={AIbuttonVisibility}
                    issueData={issueData && issueData.data}
                    getAllComments={this.getAllComments}
                  />
                )) ||
                  null}
              </div>
              <div
                className={`ah-content-wrapper ${type === "decision" &&
                  "active"}`}
              >
                {(type === "decision" && (
                  <Decision
                    isLoading={isHistoryApiLoading}
                    data={meetingDecisions}
                  />
                )) ||
                  null}
              </div>
              <div
                className={`ah-content-wrapper ${type === "history" &&
                  "active"}`}
              >
                {(type === "history" && (
                  <History
                    isLoading={isHistoryApiLoading}
                    data={history}
                    times={4}
                  />
                )) ||
                  null}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    issueData: state.issueDetailsReducer.issueData
    // upcomingMeetingsStatus: state.issueDetailsReducer.upcomingMeetingsStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      issueActivityHistoryDispatch: issueActivityHistory,
      issueActivityCommentDispatch: issueActivityComment,
      getAgeingDispatch: getAgeingAction,
      getUpcomingMeetingsDispatch: getUpcomingMeetings
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueDetailsSideBar);
